import { collection, deleteDoc, doc } from "firebase/firestore"
import { db } from "../../service/firebase"

export const deleteStore = async (storeId: string, ownerId: string) => {
  const storesRef = collection(db, `/StoreOwners/${ownerId}/allStores`)

  return deleteDoc(doc(storesRef, storeId))
}
